import React, { ReactNode } from "react";

interface TooltipProps {
  text: string;
  children: ReactNode;
  position?: "top" | "bottom" | "right" | "left";
}

export const Tooltip: React.FC<TooltipProps> = ({ text, children, position = "bottom" }) => {
  const positionClasses = position === "top"
    ? "bottom-full mb-2 -translate-x-1/2 left-1/2"
    : position === "right"
    ? "left-full ml-2 top-1/2 -translate-y-1/2"
    : position === "left"
    ? "right-full mr-2 top-1/2 -translate-y-1/2"
    : "top-full mt-2 -translate-x-1/2 left-1/2";

  const arrowClasses = position === "top"
    ? "top-full left-1/2 -translate-x-1/2 border-l-transparent border-r-transparent border-b-transparent border-t-[#050607]"
    : position === "right"
    ? "right-full top-1/2 -translate-y-1/2 border-t-transparent border-b-transparent border-l-transparent border-r-[#050607]"
    : position === "left"
    ? "left-full top-1/2 -translate-y-1/2 border-t-transparent border-b-transparent border-r-transparent border-l-[#050607]"
    : "bottom-full left-1/2 -translate-x-1/2 border-l-transparent border-r-transparent border-t-transparent border-b-[#050607]";

  return (
    <div className="relative group">
      {children}
      <div
        className={`absolute ${positionClasses}
          opacity-0 group-hover:opacity-100
          pointer-events-none
          bg-[#050607] text-white text-sm p-2 rounded shadow-lg
          whitespace-nowrap transition-opacity z-50`}
      >
        {text}
        <div
          className={`absolute ${arrowClasses} border-[6px]`}
        />
      </div>
    </div>
  );
};
